module.exports = __webpack_public_path__ + "img/vertical-three-dots.54062785.svg";